import { useMemo } from 'react';
import { ensureRicosContent } from '@wix/ricos';

export function useRicosContent(details?: string) {
  return useMemo(() => {
    return getRicosContent(details);
  }, [details]);
}

export const getRicosContent = (details?: string) => {
  if (!details) {
    return null;
  }

  return ensureRicosContent(JSON.parse(details), {
    ignoreUnsupportedValues: true,
  });
};
